import React, { useContext } from "react";
import Navbar from "../reusable/navbar";
import Style from "./ticketsDetails.module.scss";
import { useTranslation } from "react-i18next";
import SuccessIcon from "../common/assets/success-icon.svg";
import { TicketDetailsContext } from "./TicketDetailsContext";

const PaidTicketDetails = () => {
  const { t } = useTranslation();
  const { market } = useContext(TicketDetailsContext);

  return (
    <div className={Style.mainContainerDesktop}>
      <Navbar />
      <div className={Style.formResponsive}>
        <h3 className={Style.formResponsive__subtitle}>
          {t("TicketDetails.PaymentCompleted")}
        </h3>

        <div className={Style.formResponsive__content}>
          <img
            src={SuccessIcon}
            alt="success"
            className={Style.successIcon}
          />
          <p className={Style.formResponsive__paragraph}>
            {t("TicketDetails.ThisTicketHasAlreadyBeenPaid")}
          </p>
          <p className={Style.formResponsive__paragraph}>
            {t("TicketDetails.NoFurtherActionIsRequired", { context: market })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaidTicketDetails;
